import { Configuration, LogLevel, PopupRequest, RedirectRequest, SsoSilentRequest } from '@azure/msal-browser';
import { environment } from '../../environments/environment';

/**
 * Base MSAL configuration for the Bordereau app.
 *
 * The clientId / tenantId here intentionally match the AgriFinOps (App 1)
 * registration per environment. Because both SPAs target the same Entra tenant,
 * a user who has already signed into App 1 has a live Entra session cookie, which
 * lets this app acquire tokens silently (see AuthService.ssoSilent) with no prompt.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: environment.azureClientId, // Application (client) ID from Azure
    authority: `https://login.microsoftonline.com/${environment.azureTenantId}`, // Directory (tenant) ID
    redirectUri: environment.redirectUri,
    postLogoutRedirectUri: environment.redirectUri
  },
  cache: {
    // localStorage keeps the session across tabs/reloads for this origin.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) { return; }
        switch (level) {
          case LogLevel.Error: console.error(message); break;
          case LogLevel.Info: console.info(message); break;
          case LogLevel.Verbose: console.debug(message); break;
          case LogLevel.Warning: console.warn(message); break;
        }
      },
      logLevel: LogLevel.Warning
    }
  }
};

/** Scopes requested for sign-in / silent token acquisition. Mirrors App 1. */
export const loginScopes: string[] = ['User.Read'];

export const silentRequest: SsoSilentRequest = {
  scopes: loginScopes
};

export const loginRequest: RedirectRequest | PopupRequest = {
  scopes: loginScopes
};
